// @ts-nocheck
export const localeCodes =  [
  "en",
  "de",
  "es",
  "fr",
  "it",
  "ja",
  "pt",
  "zh-Hans",
  "zh-Hant"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_6fbb2e26",
      load: () => import("#nuxt-i18n/6fbb2e26" /* webpackChunkName: "locale_en_46json_6fbb2e26" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_1b45727d",
      load: () => import("#nuxt-i18n/1b45727d" /* webpackChunkName: "locale_de_46json_1b45727d" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_b2c508a6",
      load: () => import("#nuxt-i18n/b2c508a6" /* webpackChunkName: "locale_es_46json_b2c508a6" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_d645f32f",
      load: () => import("#nuxt-i18n/d645f32f" /* webpackChunkName: "locale_fr_46json_d645f32f" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_8c4de671",
      load: () => import("#nuxt-i18n/8c4de671" /* webpackChunkName: "locale_it_46json_8c4de671" */),
      cache: true
    }
  ],
  ja: [
    {
      key: "locale_ja_46json_9301f455",
      load: () => import("#nuxt-i18n/9301f455" /* webpackChunkName: "locale_ja_46json_9301f455" */),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_46json_4c0069b8",
      load: () => import("#nuxt-i18n/4c0069b8" /* webpackChunkName: "locale_pt_46json_4c0069b8" */),
      cache: true
    }
  ],
  "zh-Hans": [
    {
      key: "locale_zh_45hans_46json_c002387d",
      load: () => import("#nuxt-i18n/c002387d" /* webpackChunkName: "locale_zh_45hans_46json_c002387d" */),
      cache: true
    }
  ],
  "zh-Hant": [
    {
      key: "locale_zh_45hant_46json_1a7cd3e5",
      load: () => import("#nuxt-i18n/1a7cd3e5" /* webpackChunkName: "locale_zh_45hant_46json_1a7cd3e5" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/6489cccb" /* webpackChunkName: "config_i18n_46config_46ts_6489cccb" */)
]
export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    language: "en"
  },
  {
    code: "de",
    name: "Deutsch",
    language: "de"
  },
  {
    code: "es",
    name: "Español",
    language: "es"
  },
  {
    code: "fr",
    name: "Français",
    language: "fr"
  },
  {
    code: "it",
    name: "Italiano",
    language: "it"
  },
  {
    code: "ja",
    name: "日本語",
    language: "ja"
  },
  {
    code: "pt",
    name: "Português",
    language: "pt"
  },
  {
    code: "zh-Hans",
    name: "简体中文",
    language: "zh-Hans"
  },
  {
    code: "zh-Hant",
    name: "繁體中文",
    language: "zh-Hant"
  }
]
/** client **/

/** client-end **/